import * as React from 'react'
import { DefaultLinkFactory } from '@projectstorm/react-diagrams-defaults'
import { CustomLinkModel, linkType } from './custom-link-model'
import { CustomLinkSegment } from './custom-link-widget'

export class CustomLinkFactory extends DefaultLinkFactory {
  public constructor() {
    super(linkType)
  }

  public generateModel(event): CustomLinkModel {
    return new CustomLinkModel(event)
  }

  public generateLinkSegment(
    model: CustomLinkModel,
    _selected: boolean,
    path: string
  ) {
    return (
      <g>
        <CustomLinkSegment model={model} path={path} />
      </g>
    )
  }
}
